import React from "react";
import Mainnavigation from "./components/MainNavigation/MainNavigation";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <>
      <Mainnavigation />
      <Toaster />
    </>
  );
};

export default App;
